import { Actions, ButtonLink, Heading, Stack, Text } from 'braid-design-system';

import Routes from 'src/config/routes';

export const GenericRepostError = () => (
  <Stack space="large">
    <Heading level="3" component="h1">
      Something went wrong
    </Heading>

    <Stack space="large">
      <Text>Your order went through but we were unable to post your ad.</Text>

      <Text>
        To finish reposting, please return to your dashboard and select
        &lsquo;Repost&rsquo;.
      </Text>

      <Actions>
        <ButtonLink href={Routes.DASHBOARD} tone="formAccent">
          Go to dashboard
        </ButtonLink>
      </Actions>
    </Stack>
  </Stack>
);
